import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from "@angular/core";
import { Observable } from "rxjs";
import { UserService } from "../../../services/user.service";
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { LoaderModalService } from "../../../services/loader.service";
import { IMonth, IYear } from "../sidenav.component";
import { matchingFields } from "src/app/validators/matchTwoFormFields";
import { CommonService } from "src/app/services/common.service";
declare var $: any;

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.css"],
})
export class RegisterComponent implements OnInit {
  @ViewChild("ngOtpInput", { static: false }) ngOtpInput: any;
  auth: any;
  storeId: any;
  storeName: any;
  cartLength = 0;
  cartProduct$: Observable<any>;
  userName: string;
  otpLength: boolean = false;
  addressString = "";
  disableBTN: boolean = false;
  loginSubmit: boolean = false;
  userId: string;
  status: any;
  isSubmitted: boolean = false;
  mobileNo: any;
  loginForm: FormGroup;
  addressStatus: string;
  addressLatitude: string;
  addressLongitude: string;
  postalCode: string;
  city: string;
  state: string;
  stateCode: string;
  country: string;
  countryCode: string;
  dilveryStatus: string;
  registerData: any = "";
  mobile: string;
  email: string;
  registerForm: FormGroup;
  submitted: boolean;
  mobileNumber: "";
  verificationOTPForm: FormGroup;
  otpSubmitted: boolean = false;
  semical: Semicalender = <Semicalender>{};
  oldPassTextType: boolean;
  newPassTextType: boolean;
  cnfmPassTextType: boolean;
  forgotPassword: FormGroup;
  display: any;
  public timerInterval: any;
  otp: any;
  siteDada: any = "";
  userData: any;
  ageVerification:any
  progressbarWidth;
  resendOtp: boolean = false;
  userDetails: any;

  mySideLoginModal:boolean

  constructor(private fb: FormBuilder, private commonService: CommonService,private renderer: Renderer2, private userSrv: UserService, private router: Router, private loaderSrv: LoaderModalService, private el: ElementRef) {
    setTimeout(() => {
      this.siteDada = JSON.parse(localStorage.getItem("siteData"));
    }, 300);
    let ageVerification= sessionStorage.getItem('ageVerification')
    this.ageVerification = JSON.parse(ageVerification)
    this.createLoginForm();
    this.createRegisterForm();
    this.forgotPassword = this.fb.group({
      emailId: ["", [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    this.GetYears();
    this.GetMonths();
    this.getDays();
    this.getData();
  
    if (localStorage.getItem("addressStatus") === undefined || localStorage.getItem("addressStatus") === null) {
      $("#selectOrderStatusPopup").modal("show");
      return;
    } else {
      this.progressbarWidth = "25%";
   
      this.createVerificationOTPForm();
      this.userName = localStorage.getItem("userName");
      this.userSrv.getAuth().subscribe((res) => {
        this.auth = res;
        if (this.auth) {
          this.userName = localStorage.getItem("userName");
        }
      });
    }
  }

  getData() {
    this.commonService.Get("/homepagecontent/homepagedetails").subscribe((res) => {
      if (res["meta"]["status"]) {
        if (res?.userRegPageData != null) {
          this.registerData = res?.userRegPageData;
          sessionStorage.setItem("registerData", JSON.stringify(this.registerData));
        }
      }
    });
  }
  // password forget
 
  guestForm_emailError = "";
  isErrorEmail = false;
  onEmail(event) {
    let emailString;

    emailString = this.registerForm?.value?.emailId;

    if (emailString == "") {
      this.isErrorEmail = true;
      this.guestForm_emailError = "Please Enter a valid email";
      return false;
    }
    var mailformat = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
    let isEmailValid = mailformat.test(emailString);

    if (isEmailValid) {
      this.guestForm_emailError = "";
      this.isErrorEmail = false;

      return true;
    } else {
      this.isErrorEmail = true;

      this.guestForm_emailError = "Please Enter a valid email";
      return false;
    }
  }

  otpEmail: any;
  forgotPasswordSubmission(formValue) {
    this.submitted = true;
    if (this.forgotPassword.invalid) {
      const formGroupInvalid = this.el.nativeElement.querySelectorAll(".ng-invalid");
      formGroupInvalid[1].focus();
      this.closePassReset();
      return;
    } else {
      this.loaderSrv.startLoader("", "");
      this.commonService.sendEmailForForgotPassword(formValue.emailId.toLowerCase()).subscribe((res) => {
        if (res["meta"]["status"]) {
          this.loaderSrv.changeStateandStopLoader("success", res["meta"]["msg"], 2000);
          this.closePassReset();
          this.ngOnInit();
          this.submitted = false;
        } else {
          this.loaderSrv.changeStateandStopLoader("error", res["meta"]["msg"], 2000);
        }
      });
    }
  }

  resendOTP() {
    this.loaderSrv.startLoader("", "");
    let obj = {
      mobileNumber: this.mobileNo,
    };
    this.commonService.resendOTP(obj).subscribe((res) => {
      if (res["meta"]["status"]) {
        this.resendOtp = false;
        this.timer(2);
        this.loaderSrv.changeStateandStopLoader("success", res["meta"]["msg"], 2000);
      } else {
        this.loaderSrv.changeStateandStopLoader("error", res["meta"]["msg"], 2000);
      }
    });
  }

  changeMobileNumber() {
    this.otp = "";
    document.getElementById("mySideOtpVerify").style.width = "0";
    document.getElementById("mySideLogin").style.width = "0";
    document.getElementById("mySideRegister").style.width = "0";
    document.getElementById("mySideMobileVerify").style.width = "450px";
    const modal=  document.getElementById("mySideMobileVerify")
    modal.focus()
  }

  timer(minute) {
    let seconds: number = minute * 30;
    let textSec: any = "0";
    let statSec: number = 30;

    const prefix = minute < 10 ? "0" : "";

    this.timerInterval = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 119;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      let timer: any = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      timer = timer.split(":");
      this.display = timer[1];

      if (seconds == 0) {
        clearInterval(this.timerInterval);
        this.resendOtp = true;
      }
    }, 1000);
  }

  otpLenth() {
    if (Number(this.otp).toString().length != 6) {
      this.otpLength = true;
      this.otpSubmitted = true;
    } else {
      this.otpLength = false;
      this.otpSubmitted = false;
    }
    if (Number(this.otp).toString().length != 0) {
      this.otpLength = false;
    } else {
      this.otpLength = true;
    }
  }
  verificationFormSubmission() {
    this.otpSubmitted = true;
    var newotp: any = this.otp;
    if (Number(newotp).toString().length != 6) {
      this.otpLength = true;
      return;
    } else {
      this.loaderSrv.startLoader("", "");
      let verifyObj = {
        mobileNumber: this.mobileNo,
        otp: this.otp,
      };
      if (verifyObj.otp == 0) {
        return;
      }
      this.commonService.verifyOTP(verifyObj).subscribe((res) => {
        if (res["meta"]["status"]) {
          this.loaderSrv.changeStateandStopLoader("success", res["meta"]["msg"], 1000);
          document.getElementById("mySideOtpVerify").style.width = "0";
          document.getElementById("mySideLogin").style.width = "0";
          document.getElementById("mySideRegister").style.width = "0";
          document.getElementById("mySideMobileVerify").style.width = "0";
          localStorage.setItem("mobileVerified", "true");
          localStorage.setItem("mobile", this.mobileNumber);
          this.userSrv.updateMobileVerified(true);
          this.updatePickUpStoreData2(); //save ssddress
          this.router.navigateByUrl("/upload-id");
          this.router.navigateByUrl("/").then(() => {
            location.reload();
          });
        } else {
          this.verificationOTPForm.reset();
          this.loaderSrv.changeStateandStopLoader("error", res["meta"]["msg"], 1000);
          this.otpSubmitted = false;
        }
      });
    }
  }

  getUserData() {
    let covaid = localStorage.getItem("covaUserId");

    this.commonService.getUserProfile(covaid).subscribe((res) => {
      if (res["meta"]["status"]) {
        this.userData = res;
        localStorage.setItem("userDetails", JSON.stringify(this.userData));
        location.reload();
        this.router.navigateByUrl("/upload-id");
        this.router.navigateByUrl("/").then(() => {});
      }
    });
    return;
  }

  closePassReset() {
    document.getElementById("mySideForgotPassword").style.width = "0";
  }

  getMobileNumber(mobileNumber) {
    let sub = mobileNumber?.substring(0, 3);
    let sub1 = mobileNumber?.substring(3, 6);
    let sub2 = mobileNumber?.substring(6, 10);
    let string = sub + "-" + sub1 + "-" + sub2;
    return string;
  }

  getEmail() {}

  closeMobileVerify() {
    document.getElementById("mySideMobileVerify").style.width = "0";
  }

  updatePickUpStoreData2() {
    this.addressString = localStorage.getItem("addressString");
    this.addressStatus = localStorage.getItem("addressStatus");
    this.addressLatitude = localStorage.getItem("addressLatitude");
    this.addressLongitude = localStorage.getItem("addressLongitude");
    this.postalCode = localStorage.getItem("postal_code");
    this.city = localStorage.getItem("city");
    this.state = localStorage.getItem("state");
    this.stateCode = localStorage.getItem("stateCode");
    this.country = localStorage.getItem("country");
    this.countryCode = localStorage.getItem("countryCode");
    this.dilveryStatus = localStorage.getItem("dilveryStatus");
    this.storeId = localStorage.getItem("localStoreId");
    this.storeName = localStorage.getItem("localStoreName");
    this.userId = localStorage.getItem("covaUserId");
    this.userName = localStorage.getItem("userName");
    this.mobile = this.mobileNo;
    this.email = localStorage.getItem("email");
    let obj = {
      CustomerId: this.userId,
      AddressTypeId: 2,
      AttentionTo: this.userName,
      CountryCode: this.countryCode,
      Default: false,
      DoNotContact: true,
      Email: this.email,
      Locality: this.country,
      Notes: "",
      Phone: this.mobile,
      PostalCode: this.postalCode,
      PostOfficeBoxNumber: this.stateCode,
      StateCode: this.stateCode,
      StreetAddress1: this.addressString,
      StreetAddress2: this.city,
      currentLat: this.addressLatitude,
      currentLong: this.addressLongitude,
      formattedAddress: this.addressString,
    };
    this.commonService.saveAddress(obj).subscribe((res) => {});
  }

  openRegister() {
    document.getElementById("mySideLogin").style.width = "0";
    document.getElementById("mySideRegister").style.width = "450px";
    function myFunction(x) {
      if (x.matches) {
        document.getElementById("mySideRegister").style.width = "calc(100%)";
      }
    }    
    this.renderer.setStyle(document.body, 'cssText', 'overflow-y: hidden !important;');
    var x = window.matchMedia("(max-width: 580px)");
    myFunction(x);
    x?.addEventListener("click", myFunction); // Attach listener function on state changes
    const modal=  document.getElementById("mySideRegister")
    modal.focus()
  }

  createLoginForm() {
    this.loginForm = this.fb.group({
      emailId: ["", [Validators.required]],
      password: ["", Validators.required],
    });
  }

  get h() { return this.loginForm.controls}
  get g() { return this.registerForm.controls}
  get f() { return this.forgotPassword.controls}
  createRegisterForm() {
    this.registerForm = this.fb.group(
      {
        firstName: ["", [Validators.required]],
        lastName: ["", [Validators.required]],
        mobile: ["", [Validators.required, Validators.minLength(10)]],
        emailId: ["", [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$")]],
        password: ["", [Validators.required, Validators.minLength(6)]],
        confirmPassword: ["", [Validators.required, Validators.minLength(6)]],
      },
      {
        validator: matchingFields("password", "confirmPassword"),
      }
    );
  }


  createVerificationOTPForm() {
    this.verificationOTPForm = this.fb.group({
      otp: ["", [Validators.required]],
    });
  }

  toggleOldPassword() {
    this.oldPassTextType = !this.oldPassTextType;
  }

  toggleNewPassword() {
    this.newPassTextType = !this.newPassTextType;
  }

  toggleCnfmPassword() {
    this.cnfmPassTextType = !this.cnfmPassTextType;
  }

  loginFormSubmission(formValue) {
    this.loginSubmit = true;
    if (this.loginForm.invalid) {
      return;
    }
    let obj = {
      loginId: formValue.emailId.toLowerCase(),
      password: formValue.password,
      deviceToken: localStorage.getItem("deviceToken"),
    };
    this.loaderSrv.startLoader("", "");
    this.commonService.login(obj).subscribe((res) => {
      this.loginSubmit = false;
      if (res["meta"]["status"]) {
        const user = res["data"];
        const token: Token = res["token"];
        localStorage.setItem("userDetails", JSON.stringify(user));
        this.userDetails = localStorage.getItem("userDetails");
        this.afterLogin(user, token);
        this.loaderSrv.changeStateandStopLoader("success", res["meta"]["msg"], 2000);
      } else {
        this.loaderSrv.changeStateandStopLoader("error", res["meta"]["msg"], 2000);
      }
    });
  }

  closeRegister() {
    document.getElementById("mySideRegister").style.width = "0";
    this.renderer.setStyle(document.body, 'overflow-y', '');

  }

  closeLogin(user?: any) {
    document.getElementById("mySideLogin").style.width = "0";
  }

  openLogin() {
    document.getElementById("mySideRegister").style.width = "0";
    document.getElementById("mySideLogin").style.width = "450px";
    function myFunction(x) {
      if (x.matches) {
        document.getElementById("mySideLogin").style.width = "calc(100%)";
      }
    }

    var x = window.matchMedia("(max-width: 580px)");
    myFunction(x);
    x.addEventListener("click", myFunction); // Attach listener function on state changes
    const modal=  document.getElementById("mySideLogin")
    modal.focus()
  }

  // PASSWORD RESET----------------------------

  openPasswordReset() {
    document.getElementById("mySideLogin").style.width = "0";
    document.getElementById("mySideForgotPassword").style.width = "450px";
    function myFunction(x) {
      if (x.matches) {
        document.getElementById("mySideForgotPassword").style.width = "calc(100%)";
      }
    }
    var x = window.matchMedia("(max-width: 580px)");
    myFunction(x);
    x.addEventListener("click", myFunction); // Attach listener function on state changes
    const modal=  document.getElementById("mySideForgotPassword")
    modal.focus()
  }

  afterLogin(user, tokens) {
    this.setLocalStorage(user, tokens);
    this.userSrv.updateUserAuth(true, user);
    this.setLocalStorage(user, tokens);
  }

  setLocalStorage(user: User, token) {
    localStorage.setItem("covaUserId", user["covaUserId"]);
    localStorage.setItem("userId", user["userId"]);
    localStorage.setItem("mobileVerified", user.mobileVerified);
    localStorage.setItem("userName", user.firstName + " " + user.lastName);
    localStorage.setItem("documentVerify", user.documentVerify);
    localStorage.setItem("mobile", user["mobile"]);
    localStorage.setItem("email", user["emailId"]);
    localStorage.setItem("token", token);
    localStorage.removeItem("guestKey");
    this.updatePickUpStoreData1();
    this.router.navigateByUrl("/").then(() => {
      window.location.reload();
    });
  }

  updatePickUpStoreData1() {
    this.addressString = localStorage.getItem("addressString");
    this.addressStatus = localStorage.getItem("addressStatus");
    this.addressLatitude = localStorage.getItem("addressLatitude");
    this.addressLongitude = localStorage.getItem("addressLongitude");
    this.postalCode = localStorage.getItem("postal_code");
    this.city = localStorage.getItem("city");
    this.state = localStorage.getItem("state");
    this.stateCode = localStorage.getItem("stateCode");
    this.country = localStorage.getItem("country");
    this.countryCode = localStorage.getItem("countryCode");
    this.dilveryStatus = localStorage.getItem("dilveryStatus");
    this.storeId = localStorage.getItem("localStoreId");
    this.storeName = localStorage.getItem("localStoreName");
    this.userId = localStorage.getItem("covaUserId");
    this.userName = localStorage.getItem("userName");
    this.mobile = localStorage.getItem("mobile");
    this.email = localStorage.getItem("email");
    let obj = {
      CustomerId: this.userId,
      AddressTypeId: 2,
      AttentionTo: this.userName,
      CountryCode: this.countryCode,
      Default: false,
      DoNotContact: true,
      Email: this.email,
      Locality: this.country,
      Notes: "",
      Phone: this.mobile,
      PostalCode: this.postalCode,
      PostOfficeBoxNumber: this.stateCode,
      StateCode: this.stateCode,
      StreetAddress1: this.addressString,
      StreetAddress2: this.city,
      currentLat: this.addressLatitude,
      currentLong: this.addressLongitude,
      formattedAddress: this.addressString,
    };
    this.commonService.saveAddress(obj).subscribe((res) => {});
  }

  registerFormSubmission(formValue) {
    this.submitted = true;
    if (formValue.password != formValue.confirmPassword) {
      return;
    }
    if (formValue.password.length < 6) {
      return;
    }
    if (this.registerForm.controls["emailId"]["status"] == "INVALID") {
      return;
    }

    if (this.semical.selectdays == "" || this.semical.selectdays == "null") {
      this.loaderSrv.changeStateandStopLoader("error", "Please select day for valid age", 1000);
      return;
    }
    if (this.semical.selectmonths == "" || this.semical.selectmonths == "null") {
      this.loaderSrv.changeStateandStopLoader("error", "Please select month for valid age", 1000);
      return;
    }
    if (this.semical.selectyear == "" || this.semical.selectyear == "null") {
      this.loaderSrv.changeStateandStopLoader("error", "Please select year for valid age", 1000);
      return;
    }

    if (!this.is19age) {
      this.loaderSrv.changeStateandStopLoader("error", `Cannot Signup with under ${this.ageVerification?.age} age`, 1000);
      return;
    }

    if (this.registerForm.invalid) {
      const formGroupInvalid = this.el.nativeElement.querySelectorAll(".ng-invalid");
      formGroupInvalid[1].focus();
      return;
    } else {
      let obj = {
        confirmation: formValue.confirmPassword,
        devicetokenid: "863e02f0ace476e0c565b7e98e8bc280e8b23ca1b7c8a566592df1987b4cb81d",
        emailId: formValue.emailId.toLowerCase(),
        firstName: formValue.firstName,
        lastName: formValue.lastName,
        mobile: formValue.mobile,
        is_subscribed: "1",
        signuptype: "web",
        password: formValue.password,
        code: formValue.code,
        dob: this.finalselectyear + "-" + this.finalMonthselect + "-" + this.finaldayselect, //formValue.dob,

        hearFrom: formValue.hearFrom,
        deviceToken: localStorage.getItem("deviceToken"),
        token: localStorage.getItem("covatoken"),
      };
      this.loaderSrv.startLoader("", "");
      this.disableBTN = true;
      this.commonService.register(obj).subscribe((res: any) => {
        this.disableBTN = false;
        if (res["meta"]["status"]) {
           this.onRegisterSuccess()
          const user: User = res["data"];
          sessionStorage.setItem("user", JSON.stringify(user));
          const token: Token = res["token"];
          this.afterLogin1(user, token);
          this.loaderSrv.changeStateandStopLoader("success", res.meta.msg, 1000);
          this.loaderSrv.stopLoader();
          if (this.registerData && this.registerData.uploadId) {
            this.router.navigateByUrl("/upload-id");
          } else if (this.registerData && this.registerData?.verifyMobile && !user?.mobileVerified) {
            this.openMobileVerify();
          } else {
            this.router.navigateByUrl("/").then((res) => {
              window.location.reload();
            });
          }
          this.registerForm.reset();
          this.closeRegister();
          localStorage.setItem("userId", res["data"]["userId"]);
        } else {
          this.isErrorEmail = true;
          this.guestForm_emailError = res["meta"]["msg"];
          this.loaderSrv.changeStateandStopLoader("error", res.meta.msg, 2000);
        }
      });
    }
  }


  onRegisterSuccess() {
  const script = document.createElement('script');
  script.innerHTML = `
    gtag('event', 'registration_success', {
      'method': 'signup_form'
    });
  `;
  document.body.appendChild(script);
}
  closeOtpVerify() {
    document.getElementById("mySideOtpVerify").style.width = "0";
  }

  openOtpVerify() {
    document.getElementById("mySideLogin").style.width = "0";
    document.getElementById("mySideRegister").style.width = "0";
    document.getElementById("mySideMobileVerify").style.width = "0";
    document.getElementById("mySideOtpVerify").style.width = "450px";
    function myFunction(x) {
      if (x.matches) {
        document.getElementById("mySideOtpVerify").style.width = "calc(100%)";
      }
    }

    var x = window.matchMedia("(max-width: 580px)");
    myFunction(x);
    x.addEventListener("click", myFunction); // Attach listener function on state changes
    const modal=  document.getElementById("mySideOtpVerify")
    modal.focus()
  }

  afterLogin1(user, tokens) {
    this.setLocalStorage1(user, tokens);
    this.userSrv.updateUserAuth(true, user);
  }

  openMobileVerify() {
    document.getElementById("mySideLogin").style.width = "0";
    document.getElementById("mySideRegister").style.width = "0";
    document.getElementById("mySideMobileVerify").style.width = "450px";
    function myFunction(x) {
      if (x.matches) {
        document.getElementById("mySideMobileVerify").style.width = "calc(100%)";
      }
    }

    var x = window.matchMedia("(max-width: 580px)");
    myFunction(x);
    x?.addEventListener("click", myFunction); // Attach listener function on state changes
    const modal=  document.getElementById("mySideMobileVerify")
    modal.focus()
  }

  setLocalStorage1(user: User, token) {
    localStorage.setItem("userId", user["userId"]);
    localStorage.setItem("email", user["emailId"]);
    localStorage.setItem("mobile", user["mobile"]);
    localStorage.setItem("covaUserId", user["covaUserId"]);
    localStorage.setItem("mobileVerified", user.mobileVerified);
    localStorage.setItem("userName", user.firstName + " " + user.lastName);
    localStorage.setItem("documentVerify", user.documentVerify);
    localStorage.setItem("token", token);
  }

  otpFormSubmission() {
    this.isSubmitted = true;
    this.resendOtp = false;
    if (this.mobileNo == undefined) {
      return;
    }
    if (this.mobileNo.length < 10) {
      return;
    }

    this.loaderSrv.startLoader("", "");

    let mobileObj = {
      mobileNumber: this.mobileNo,
    };
    this.commonService.sendOTP(mobileObj).subscribe((res) => {
      if (res["meta"]["status"]) {
        this.timer(1);
        this.submitted = false;
        this.updatePickUpStoreData2();
        this.loaderSrv.changeStateandStopLoader("success", res["meta"]["msg"], 2000);
        this.openOtpVerify();
      } else {
        this.loaderSrv.changeStateandStopLoader("error", res["meta"]["msg"], 2000);
      }
    });
  }

  labelClickedDate: boolean = false;
  LabelClicked(e) {
    this.labelClickedDate = true;
    /*   alert("clicked") */
  }
  keyPressNumbers(event) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  monthlist: IMonth[] = [];
  statelist: IMonth[] = [];
  month: IMonth = <IMonth>{};
  year: IYear = <IYear>{};
  years = [];

  onOtpChange(otp) {
    this.otp = otp;

    if (Number(otp).toString().length == 6) {
    }
  }

  // work for date selector dropdown
  GetMonths() {
    this.monthlist = [];
    for (let i = 1; i <= 12; i++) {
      this.month = <IMonth>{};

      if (i.toString().length == 1) {
        this.month.text = i.toString();
        this.month.value = i.toString();
      } else {
        this.month.text = i.toString();
        this.month.value = i.toString();
      }

      this.monthlist.push(this.month);
    }
  }

  row = [];
  thiscurremtYear: any;
  GetYears() {
 
    // if (this.ageVerification?.age == undefined || this.ageVerification?.age == "" || this.ageVerification?.age == null) {
    //   // this.ageVerification['age'] = 19;
    // }
    this.years = [];
    let curyear = new Date().getFullYear();
    for (let i = curyear - Number(this.ageVerification?.age ? this.ageVerification?.age:19); i > 1901; i < i--) {
      this.year = <IYear>{};
      this.year.text = i.toString();
      this.year.value = i.toString();
      this.years.push(this.year);
    }
  }
  daysArray = [];
  getDays() {
    for (let ki = 1; ki <= 31; ki++) {
      this.daysArray.push({
        text: "day",
        value: ki,
      });
    }
  }
  finalselectyear = 0;
  finalMonthselect = "";
  finaldayselect = "";
  is19age: boolean = false;
  onSelectMonth(monval) {
    this.finalMonthselect = monval;
  }
  onSelectYear(year) {
    let years = new Date().getFullYear();

    this.finalselectyear = Number(year);
    let yourage = this.getDifference(years, this.finalselectyear);
    if (yourage < Number(this.ageVerification?.age ? this.ageVerification?.age:19)) {
      this.is19age = false;
    } else {
      this.is19age = true;
    }
  }
  getDifference(a, b) {
    return Math.abs(a - b);
  }
  onSelectDay(day) {
    this.finaldayselect = day;
  }
  // leter ony for name

  lettersOnly(event) {
    const str = event.target.value;
    const str2 = str.charAt(0).toUpperCase() + str.slice(1);
    event.target.value = str2;
    var charCode = event.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8) return true;
    else return false;
  }
}

interface User {
  userId: string;
  mobileVerified: string;
  firstName: string;
  lastName: string;
  documentVerify: string;
}

interface Token {
  token: string;
}

export class Semicalender {
  selectyear: any = "";
  selectmonths: string = "";
  selectdays: string = "";
  /* zipCode:string; */
}

